import "core-js/modules/es.array.map.js";
import React from 'react';
import { Small } from '@finect/tabular-core/Small';
import { ParagraphSmall } from '@finect/tabular-core/Paragraph';
import { PercentLabel, AssetsLabel } from '../../../Labels';
import { GenericTable } from '../../../GenericTable';
import { HoldingName } from './partials';
export var FundPortfolio = function FundPortfolio(_ref) {
  var fund = _ref.fund;
  var portfolio = fund.portfolio;
  var currency = fund.currency;
  var rows = portfolio.holdings.map(function (holding) {
    var name = holding.name,
      weight = holding.weight,
      amount = holding.amount,
      isin = holding.isin;
    return {
      match: false,
      cells: [{
        params: {
          textAlign: 'left'
        },
        component: React.createElement("div", null, React.createElement(HoldingName, null, name), isin ? React.createElement(Small, null, isin) : null)
      }, {
        params: {
          textAlign: 'right'
        },
        component: React.createElement(AssetsLabel, {
          currency: currency === null || currency === void 0 ? void 0 : currency.code,
          value: amount,
          decimals: 0
        })
      }, {
        params: {
          textAlign: 'right'
        },
        component: React.createElement(PercentLabel, {
          value: weight,
          decimals: 2
        })
      }]
    };
  });
  return React.createElement("div", null, React.createElement(ParagraphSmall, null, '10 mayores posiciones en cartera'), React.createElement(GenericTable, {
    fetching: false,
    fetchingSkeletonItems: 10,
    columns: [{
      params: {
        textAlign: 'left'
      },
      component: 'Posición'
    }, {
      params: {
        textAlign: 'right'
      },
      component: 'Valor'
    }, {
      params: {
        textAlign: 'right'
      },
      component: 'Peso'
    }],
    rows: rows,
    size: "small"
  }));
};